<template>
    <div ref="myGridDetailsCrud" :crudtitle="crudtitle">
        <JqxGrid ref="myGridDetails" :theme="'material'"
                 :width="'100%'" :columnsresize="true"
                 :editable="false" :sortable="true" :altrows="true"
                 :showtoolbar="false"
                 :autoheight="true" :pageable="true" :pagermode="'default'"
                 :pagesizeoptions=" ['10', '20', '30', '100'] " :pagesize="20"
                 :groupable="true" :showfilterrow="true"
                 :filterable="true" :autoshowfiltericon="true"
                 :selectionmode="'singlecell'"
        >
        </JqxGrid>
    </div>
</template>

<script>
    import JqxGrid from "~jqx/jqwidgets-vue/vue_jqxgrid.vue";
    import {mapGetters} from 'vuex';

    let source;
    export default {
        name: "JqxDetailsCheck",
        components: {
            JqxGrid,
        },
        props: {
            crudtitle: {type: String, default: 'Tabella Check'},
        },
        data: function () {
            return {
                theme: "theme",
                crudmodel: {type: String},
            }
        },
        computed: mapGetters({
            user: 'auth/user',
            //position: 'position/pos'
        }),
        mounted: function () {
            source = {
                datatype: 'json',
                id: 'id',
                url: this.crudmodel,
                processdata: function (data) {
                    data.featureClass = "P";
                    data.style = "full";
                    data.maxRows = 50;
                },
            };
        },
        methods: {
            // buildAccessoryColumnsCustom: function (data) {
            //
            //     let z = {
            //         text: 'ubicazione',
            //         datafield: 'ubicazione_id',
            //         displayfield: 'ubicazione',
            //         columntype: 'combobox',
            //         createeditor: (row, column, editor) => {
            //             // assign a new data source to the combobox.
            //             editor.jqxComboBox({
            //                 autoDropDownHeight: true,
            //                 source: listubicazioni,
            //                 promptText: 'Please Choose:',
            //                 displayMember: 'ubicazione',
            //                 valueMember: 'ubicazione_id'
            //             });
            //         },
            //         // update the editor's value before saving it.
            //         cellvaluechanging: (row, column, columntype, oldvalue, newvalue) => {
            //             // return the old value, if the new value is empty.
            //             if (newvalue == '') return oldvalue;
            //         }
            //     };
            //     let c = [];
            //     c.push(z);
            //     return c;
            // },
            cellsrenderer: function(row, columnsfield, value){
                if(value){
                    return '<div style="display:flex;justify-content:center;align-items:center;height:100%;"><img src="/img/check.gif" alt="Check OK"/></div>';
                } else {
                    return '<div style="display:flex;justify-content:center;align-items:center;height:100%;"><img src="/img/prenotata.gif" alt="Check FALLITO"/></div>';
                }
            },
            // cellsrenderer: function (row, columnsfield, value, defaulthtml, columnproperties, rowdata) {
            //     if (value < 20) {
            //         return '<span style="margin: 4px; float: ' + columnproperties.cellsalign + '; color: #ff0000;">' + value + '</span>';
            //     }
            //     else {
            //         return '<span style="margin: 4px; float: ' + columnproperties.cellsalign + '; color: #008000;">' + value + '</span>';
            //     }
            // },

            dataCreationCustomDetails: function () {
                source = {
                    datatype: 'json',
                    id: 'id',
                    url: this.crudmodel,
                    processdata: function (data) {
                        data.featureClass = "P";
                        data.style = "full";
                        data.maxRows = 50;
                    },
                };
                const dataAdapter = new jqx.dataAdapter(source, {
                    autoBind: true,
                    downloadComplete: (data) => {
                        let columns = data[0].columns;
                        columns[5].cellsrenderer = this.cellsrenderer;
                        //console.log("colonne: ", columns);
                        // let accessoryColumns = this.buildAccessoryColumnsCustom(data);
                        // columns.push(
                        //     accessoryColumns[0],
                        // );
                        let rows = data[1].rows;
                        let datafields = data[2].datafields;
                        let maxid = data[3];
                        let gridAdapter = new jqx.dataAdapter({
                            datafields: datafields,
                            id: 'id',
                            localdata: rows,
                        });
                        this.$refs.myGridDetails.hideloadelement();
                        this.$refs.myGridDetails.beginupdate();
                        this.$refs.myGridDetails.setOptions
                        ({
                            source: gridAdapter,
                            columns: columns,
                        });
                        this.$refs.myGridDetails.endupdate();
                        //listarticoli = data[4];
                    }
                });


            },
            setQueryModel(data) {
                this.crudmodel = data;
                //this.dataCreationCustomDetails();
            },
            getvalori() {
                return this.$refs.myGridDetails.getrows();
            },
        }
    }
</script>

<style scoped>

</style>
